import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IFieldPreferences } from '@app/components/form/services/schema-form/schema-form-interfaces';

@Component({
  selector: 'xvi-stand-worksheet-summary',
  templateUrl: './xux-stand-worksheet-summary.component.html',
  styleUrls: ['./xux-stand-worksheet-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxStandWorksheetSummaryComponent implements OnInit {
  @Input() public field: IFieldPreferences = {};

  public constructor() {}

  public ngOnInit() {}
}
